(function () {
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    var header = document.querySelector('[data-ek-header]');
    if (header) {
      var btns = header.querySelectorAll('[data-ek-menu]');
      var panels = header.querySelectorAll('[data-ek-panel]');
      var closeTimer = null;
      var openId = null;
      function closeAll() {
        openId = null;
        btns.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
        panels.forEach(function (p) { p.hidden = true; });
      }
      function open(id) {
        clearTimeout(closeTimer);
        if (openId === id) return;
        openId = id;
        btns.forEach(function (b) { b.setAttribute('aria-expanded', b.getAttribute('data-ek-menu') === id ? 'true' : 'false'); });
        panels.forEach(function (p) { p.hidden = p.getAttribute('data-ek-panel') !== id; });
      }
      btns.forEach(function (b) {
        var id = b.getAttribute('data-ek-menu');
        b.addEventListener('mouseenter', function () { if (window.matchMedia('(hover: hover)').matches) open(id); });
        b.addEventListener('click', function () { if (openId === id) closeAll(); else open(id); });
      });
      header.addEventListener('mouseleave', function () { closeTimer = setTimeout(closeAll, 180); });
      header.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
      document.addEventListener('click', function (e) { if (!header.contains(e.target)) closeAll(); });

      panels.forEach(function (panel) {
        var subs = panel.querySelectorAll('[data-ek-sub]');
        var panes = panel.querySelectorAll('[data-ek-pane]');
        function pick(i) {
          subs.forEach(function (s) { var on = s.getAttribute('data-ek-sub') === i; s.classList.toggle('is-active', on); s.setAttribute('aria-selected', on ? 'true' : 'false'); });
          panes.forEach(function (p) { p.hidden = p.getAttribute('data-ek-pane') !== i; });
        }
        subs.forEach(function (s) {
          var i = s.getAttribute('data-ek-sub');
          s.addEventListener('mouseenter', function () { pick(i); });
          s.addEventListener('click', function () { pick(i); });
          s.addEventListener('focus', function () { pick(i); });
        });
      });

      var burger = header.querySelector('[data-ek-burger]');
      var drawer = header.querySelector('[data-ek-drawer]');
      if (burger && drawer) {
        burger.addEventListener('click', function () {
          var show = drawer.hidden;
          drawer.hidden = !show;
          burger.setAttribute('aria-expanded', show ? 'true' : 'false');
        });
      }
    }

    document.querySelectorAll('[data-ek-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      wrap.querySelectorAll('[data-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          var min = parseInt(input.min || '0', 10);
          var v = Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(b.getAttribute('data-step'), 10));
          input.value = v;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });

    document.querySelectorAll('[data-ek-autosubmit]').forEach(function (el) {
      el.addEventListener('change', function () { el.form.submit(); });
    });

    var variantSelect = document.querySelector('[data-ek-variant]');
    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        var opt = variantSelect.options[variantSelect.selectedIndex];
        var price = document.querySelector('[data-ek-price]');
        var compare = document.querySelector('[data-ek-compare]');
        var btn = document.querySelector('[data-ek-add]');
        if (price) price.textContent = opt.getAttribute('data-price');
        if (compare) compare.textContent = opt.getAttribute('data-compare') || '';
        if (btn) { var ok = opt.getAttribute('data-available') === 'true'; btn.disabled = !ok; btn.textContent = ok ? btn.getAttribute('data-label') : btn.getAttribute('data-soldout'); }
        var url = new URL(window.location.href); url.searchParams.set('variant', variantSelect.value);
        window.history.replaceState({}, '', url.toString());
      });
    }
  });
})();
